import React from 'react'
import { useTranslation, Trans } from 'react-i18next'

require('./MobileMessage.scss')

const MobileMessage = () => {
    const { t } = useTranslation()
    return (
        <div className="MobileMessage">
            <span className="MobileMessage">
                <h1>{t('mobile.not supported')}</h1>
                <p>
                    <Trans i18nKey="mobile.meanwhile visit sugarcube">
                        In the meantime, please use a <strong>desktop or laptop</strong> to access Sugarcube, and enjoy
                        our magical decoration experience.
                    </Trans>
                </p>
            </span>
            <img src={`${ASSET_BUCKET}/graphics/big_devices.png`} alt={t('common.alt.design on desktop')} />
        </div>
    )
}
export default MobileMessage
